module.exports = __webpack_public_path__ + "7e4b29ba/img/menu-icon.5f8facae.svg";